$(document).ready(() => {
  const bundle = async (ID, productTitle, productSKU, var_id, form_id) => {
    const formData1 = {
      items: [
        {
          id: ID,
          quantity: 1,
          properties: {
            Product: productTitle,
            '_Product SKU': productSKU,
          },
        },
      ],
    };
    const addToCartForm = document.getElementById(form_id);
    const formData2 = new FormData(addToCartForm);
    //console.log("formData2");
    //console.log(formData2);

    if (window.location.href.indexOf('#only-frame') > -1) {
      const frame = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData1),
      }).then(response => {
        return response.json();
      });

      let props = {};

      $.getJSON('/cart.js', (cart) => {
        for (let i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id === var_id) {
            props = Object.assign({}, cart.items[i].properties);
            const qty = cart.items[i].quantity - 1;
            jQuery
              .ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  id: var_id,
                  quantity: qty,
                },
                dataType: 'json',
                success: function (result) {},
                error: function (jqxhr, status, exception) {},
              })
              .then(() => {
                props.Frame = 'Framed';
                props.Framed = '';
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    id: var_id,
                    quantity: 1,
                    properties: props,
                  },
                  dataType: 'json',
                  success: function (result) {},
                  error: function (jqxhr, status, exception) {
                    // Handle error
                  },
                });
              });
          }
        }
      });

      $.getJSON('/cart.js', (cart) => {});

      frame;

      history.pushState(
        '',
        document.title,
        window.location.pathname + window.location.search
      );
    } else {
      const frame = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData1),
      }).then(response => {
        return response.json();
      });

      const product = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData2,
      }).then(response => {
        return response.json();
      });

      frame;
      product;
    }
  };

  $(() => {
    $('.product-form__submit').click(function (e) {
      e.preventDefault();
      const product_wrapper = $(this).closest('.main-product');
      const selectSKU = product_wrapper
        .find('.options-size option:selected')
        .attr('data-sku');
      const product = product_wrapper.find('.frameid').attr('data-product');
      const variant = product_wrapper
        .find('.options-frame option:not(.hide):selected')
        .attr('data-variant');
      const var_id = product_wrapper
        .find('.main-product__select option:selected')
        .attr('data-variant-id');
      const form_id = product_wrapper.find('form[action="/cart/add"]').attr('id');
      //console.log("var_id:", var_id );
      // console.log("productdd:", product );
      bundle(variant, product, selectSKU, var_id, form_id);
    });

    if (window.location.href.indexOf('#only-frame') > -1) {
      $('.options-frame option:not(.hide)[value="Framed"]').prop(
        'selected',
        true
      );
      $('data-framed').val('Framed');
      $('.product__media').addClass('product__media--black');
    }
  });
});
